







































import { Component, Prop, Vue } from 'vue-property-decorator';
import { mdbRow, mdbCol, mdbInput, mdbSelect, mdbBtn } from '@folky-tools/mdbvue';
import { Attribute } from '@/models/references-classification/attribute';
import { AttributeValue } from '@/models/references-classification/attribute-value';
import { required } from 'vuelidate/lib/validators';
import Swal from 'sweetalert2';

@Component({
    components: {
        mdbRow,
        mdbCol,
        mdbInput,
        mdbSelect,
        mdbBtn
    },
    validations: {
        attribute: { name: { required } }
    }
})
export default class EditAttribute extends Vue {
    @Prop(Attribute) private attribute!: Attribute;
    private attributeCopy: Attribute = new Attribute();
    private attributeNameMaxCharLength: number = 32;
    private attributeValueMaxCharLength: number = 32;

    private beforeMount(): void {
        this.attributeCopy = this.attribute.clone();
    }

    private hasErrors(): boolean {
        this.$v.attribute.$touch();
        if (this.$v.attribute.$error) {
            return true;
        }
        return false;
    }

    private addAttrValue(): void {
        const attrValue: any = new AttributeValue();
        this.attribute.values.push(attrValue);
    }

    private async removeAttrValue(index: number, valueName: string): Promise<void> {
        if (valueName) {
            const questionResult = await Swal.fire({
                title: this.$i18n.t('components.businesses.editAttribute.actions.deleteValue.modal.title').toString(),
                html: '<h3>' + valueName + '</h3>' + this.$i18n.t('components.businesses.editAttribute.actions.deleteValue.modal.textHtml').toString(),
                type: 'warning',
                showCancelButton: true,
                reverseButtons: true,
                focusConfirm: false,
                focusCancel: true,
                confirmButtonText: this.$i18n.t('components.businesses.editAttribute.actions.deleteValue.modal.confirm.doConfirm').toString(),
                cancelButtonText: this.$i18n.t('components.businesses.editAttribute.actions.deleteValue.modal.doCancel').toString(),
                customClass: {
                    confirmButton: 'btn btn-primary',
                    cancelButton: 'btn btn-danger'
                },
                animation: false
            });
            if (questionResult.value) {
                this.attribute.values.splice(index, 1);
            }
        } else {
            this.attribute.values.splice(index, 1);
        }
    }
}
